"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Radio = ({
  onChange,
  onMouseUp,
  boxed,
  children,
  ...props
}) => {
  const ariaLabel = props['aria-label'] ?? children ? undefined : 'Radio button';
  return (0, _jsxRuntime.jsxs)("label", {
    css: theme => [_styles.styles.default(theme), props.vertical && _styles.styles.vertical, props.disabled && _styles.styles.disabled(theme), boxed && _styles.styles.boxed],
    onClick: props.onClick,
    onMouseUp: onMouseUp,
    children: [(0, _jsxRuntime.jsx)("input", {
      type: "radio",
      name: props.name,
      disabled: props.disabled,
      defaultChecked: props.checked,
      onChange: onChange,
      "aria-label": ariaLabel // Add an aria-label if children is not descriptive enough
      ,
      ...props
    }), children, (0, _jsxRuntime.jsx)("span", {})]
  });
};
var _default = exports.default = Radio;